export default {
  panel: {
    padding: '10px',
    marginTop: '20px'
  }
};
